<div class="modal">
  <div class="modalOverlay"></div>
  <div class="modalContainer">
    <div class="modalContent">
      <h5 class="modalContentTitle">
        メールアドレス確認
      </h5>
      <p>
        登録したメールアドレスに認証用メールをお送りいたしました。ご確認ください。
      </p>
    </div>
    <div class="modalControl">
      <a (click)="onConfirm()">OK</a>
    </div>
  </div>
</div>
